import React from 'react';

const DotSeparator = () => <>&nbsp;&bull;&nbsp;</>;

export default DotSeparator;
